"use client";
import "react";
import { twMerge as e } from "tailwind-merge";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-radio-group";
//#region src/components/atoms/RadioGroupItem/RadioGroupItem.tsx
var r = ({ checked: r, ...i }) => /* @__PURE__ */ t(n.Item, {
	"data-slot": "radio-group-item",
	checked: r,
	className: e("\n                w-4 h-4\n                rounded-full\n                border-2\n                border-gray-300\n                bg-white\n                focus:outline-none\n                focus:ring-blue-500\n                focus:ring-1\n                focus:ring-offset-2\n            ", r && "outline-none ring-1 ring-offset-2 ring-blue-500 bg-blue-500 border-white"),
	...i,
	children: /* @__PURE__ */ t(n.Indicator, { "data-slot": "radio-group-indicator" })
});
r.displayName = "RadioGroupItem";
//#endregion
export { r as RadioGroupItem };
